export default function truncate(stringValue: string, max: number) {
  const escapedStringValue = stringValue.replace(
    /[\\"\n\r]/g,
    function (match) {
      return match === '\n' ? '\\n' : match === '\r' ? '\\r' : '\\\\';
    }
  );
  const parsedString = JSON.parse(`{"value": "${escapedStringValue}"}`).value; // Obliger de faire ça car les \r\n sont interprétés lttéralement plutôt que comme des caractères de nouvelle ligne
  let sanitizeStr = parsedString.replace(/<\/?[^>]+(>|$)/g, '');
  sanitizeStr = sanitizeStr.replace(/\r?\n|\r/g, ''); // Supprime les "\r\n"
  let array = sanitizeStr
    .trim()
    .split(' ')
    .filter((str: string) => str !== '');
  const ellipsis = array.length > max ? '...' : '';

  return array.slice(0, max).join(' ') + ellipsis;
}
